import { useTheme } from '@mui/material';

export const IntroIcon2 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                d="M24 10.0179C27.3125 10.0179 30 12.7054 30 16.0179V20.0179H18V16.0179C18 12.7054 20.6875 10.0179 24 10.0179ZM16 16.0179V20.0179H15C12.2375 20.0179 10 22.2554 10 25.0179V35.0179C10 37.7804 12.2375 40.0179 15 40.0179H33C35.7625 40.0179 38 37.7804 38 35.0179V25.0179C38 22.2554 35.7625 20.0179 33 20.0179H32V16.0179C32 11.5992 28.4188 8.01794 24 8.01794C19.5813 8.01794 16 11.5992 16 16.0179ZM15 22.0179H33C34.6562 22.0179 36 23.3617 36 25.0179V35.0179C36 36.6742 34.6562 38.0179 33 38.0179H15C13.3438 38.0179 12 36.6742 12 35.0179V25.0179C12 23.3617 13.3438 22.0179 15 22.0179ZM25 27.5179C25 26.9679 24.55 26.5179 24 26.5179C23.45 26.5179 23 26.9679 23 27.5179V32.5179C23 33.0679 23.45 33.5179 24 33.5179C24.55 33.5179 25 33.0679 25 32.5179V27.5179Z"
                fill={primaryIconStrokeColor}
            />
        </svg>
    );
};
